import { createStore/*, compose */} from 'redux';

import rootReducer from './reducers/index';

const defaultState = {
  itemList: [],
  applicationState: {selectedItem: -1, selectedTool: 0},
};

// const enhancers = compose(
//   window.devToolsExtension ? window.devToolsExtension() : f => f
// );

const store = createStore(
  rootReducer, 
  defaultState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

//adding hot reloading to redux store
if(module.hot){
  module.hot.accept('./reducers', () => {
    const nextRootReducer = require('./reducers/index').default;
    store.replaceReducer(nextRootReducer);
  });
}

export default store;


// WEBPACK FOOTER //
// ./src/store.js